"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultLocale = void 0;
exports.DefaultLocale = {
    label: "English (United States)",
    value: "en-US",
    date_format: "MM/dd/yyyy",
    time_format: "h:mm a",
    first_day_of_week: 0,
};
